<div class="dashboard">
  <h3>ESTADO GENERAL Y ALARMAS</h3>
  <hr />
  <div class="status">
    <div
      class="status__online"
      [ngClass]="{ status__secondary: alarms?.onlines == 0 }"
    >
      <div class="status__online__number">{{ alarms?.onlines }}</div>
      <div class="status__online__label">ONLINE</div>
    </div>
    <div
      class="status__offline"
      [ngClass]="{ status__secondary: alarms?.offlines == 0 }"
    >
      <div class="status__offline__number">{{ alarms?.offlines }}</div>
      <div class="status__offline__label">OFFLINE</div>
    </div>
    <div
      class="status__warnings"
      [ngClass]="{ status__secondary: alarms?.warning == 0 }"
    >
      <div class="status__warnings__number">{{ alarms?.warning }}</div>
      <div class="status__warnings__label">WARNINGS</div>
    </div>
    <div
      class="status__criticals"
      [ngClass]="{ status__secondary: alarms?.critical == 0 }"
    >
      <div class="status__criticals__number">{{ alarms?.critical }}</div>
      <div class="status__criticals__label">CRITICALS</div>
    </div>
  </div>
</div>
